import React from "react"
import { useTranslation } from "react-i18next"
import { FaRegFrown } from "react-icons/fa"
import { AiOutlineQuestionCircle } from "react-icons/ai"

import Quote from "../common/Quote"

const MyStory = () => {
  const { t } = useTranslation()

  const challenges = t("about.my-story.challenges", {
    returnObjects: true,
  })

  return (
    <section className="mx-auto max-w-7xl p-8 space-y-4">
      <h2 className="text-xl md:text-2xl font-semibold">
        {t("about.my-story.title")}
      </h2>
      <div className="py-5">
        <Quote
          text={t("about.my-story.introduction.quote")}
          author={t("about.my-story.introduction.quote-author")}
        />
        <div className="mt-5">
          <p className="text-lg">
            {t("about.my-story.introduction.paragraph")}
          </p>
        </div>
        <div className="flex flex-col bg-blue-200 p-5 rounded-lg shadow-lg space-y-3 m-5">
          <ul className="space-y-3">
            {challenges.map((challenge, index) => (
              <li key={index} className="flex items-center space-x-2">
                <FaRegFrown className="text-grey-500" />
                <p className="text-grey-500">{challenge}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-5">
          <p className="text-lg">{t("about.my-story.realization.paragraph")}</p>
        </div>
        <div className="rounded my-2 transition-all p-4">
          <div className="flex items-center justify-center mb-4">
            <AiOutlineQuestionCircle size={50} className="text-blue-500" />
          </div>
          <h2 className="text-2xl font-bold text-blue-500 mb-4 text-center">
            {t("about.my-story.here-i-am.title")}
          </h2>
        </div>
        <div className="mt-5">
          <p className="text-lg">{t("about.my-story.here-i-am.paragraph")}</p>
        </div>
      </div>
    </section>
  )
}

export default MyStory
